import React from "react";
import { Modal, Button } from "react-bootstrap";
import ProcessesStatus from "../fragments/ProcessesStatus";

class ResubmitLoanConfirmation extends React.Component {

  makeAction() {
    this.props.resubmitAction();
    this.props.handleClose();
  }

  render() {
    return (
      <Modal show={ this.props.showResubmit } onHide={() => this.props.handleClose()} >

        <Modal.Header closeButton>
          <Modal.Title>Confirm submission</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <h3>Are you sure you want to resubmit the loan for approval?</h3>

          <ProcessesStatus
            error={ this.props.isProcessFailed
              ? this.props.processResult.result.text
              : null
            }
            running={ this.props.isProcessRunning }
            success={ this.props.isProcessSuccessful }
          />

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => this.props.handleClose()}>Cancel</Button>
          <Button onClick={() => this.makeAction()} bsStyle="primary" 
            disabled={ this.props.isProcessRunning }>Resubmit</Button>
        </Modal.Footer>

      </Modal>
    )
  }
}

export default ResubmitLoanConfirmation;



// WEBPACK FOOTER //
// ./src/components/Loans/ResubmitLoanConfirmation.js